import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import PatientsDialogDocumentsListEmpty from './PatientsDialogDocumentsListEmpty';
import PatientsDialogDocumentsListItem from './PatientsDialogDocumentsListItem';

const styles = () => ({
  root: {
    width: '100%',
    overflow: 'hidden',
  },
  table: {
    minWidth: 500,
  },
});

const PatientsDialogDocumentsList = ({
  documents,
  onDocumentClick,
  business,
  classes,
}) => (
  <div className={classes.root}>
    {documents.length === 0 ? (
      <PatientsDialogDocumentsListEmpty />
    ) : (
      <Table className={classes.table}>
        <TableBody>
          {documents.map(document => (
            <PatientsDialogDocumentsListItem
              key={document.ID}
              {...document}
              {...onDocumentClick ? { onClick: () => { onDocumentClick(document); } } : {}}
              business={business}
            />
          ))}
        </TableBody>
      </Table>
    )}
  </div>
);

PatientsDialogDocumentsList.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onDocumentClick: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsDialogDocumentsList.defaultProps = {
  onDocumentClick: null,
  business: {},
};

export default withStyles(styles)(PatientsDialogDocumentsList);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogDocumentsList.js